import { keepPreviousData, useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewCategory = (page = 1, limit = 10, q = "") => {
    const normalizedSearch = q.trim();

    return useQuery({ 
        queryKey: ['viewcategory', page, limit, normalizedSearch], 
        queryFn: async () => { 
            const res = await api.get('/categories/show', {
                params: {
                    includeInactive: true,
                    page,
                    limit,
                    ...(normalizedSearch ? { q: normalizedSearch } : {}),
                }
            }); 
            return res.data; 
        },
        placeholderData: keepPreviousData,
        staleTime: 30000,
     });
};  